var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-wrapper"},[_c('a',{class:_vm.classes,attrs:{"id":"pwd-copy-btn","href":_vm.link,"data-toggle":"modal","data-target":"#pwg-promo-modal"}},[_c('span',[_vm._v(_vm._s(this.caption))]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37ae7382","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button.vue
// module id = null
// module chunks = 